import {
  AD_DETAILS_2_COLUMN_MAX_WIDTH,
  BRAND_COLOR,
} from "@/app/layout/LayoutConstants";
import { AdGalleryItem } from "@/models/AdDetailModel";
import { Box } from "@mui/material";
import useEmblaCarousel from "embla-carousel-react";
import { useEffect } from "react";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { DarkIconButton } from "@/app/shared/DarkIconButton";

const THUMBNAIL_WIDTH = 120;
const THUMBNAIL_ASPECT_RATIO = 0.75;
export const THUMBNAIL_HEIGHT = THUMBNAIL_WIDTH * THUMBNAIL_ASPECT_RATIO;
export const THUMBNAIL_SPACING = 0.5;

function ThumbnailsCarousel({
  items,
  activeIndex,
  isFullScreen,
  onThumbnailClicked,
}: {
  items: AdGalleryItem[];
  activeIndex: number;
  isFullScreen: boolean;
  onThumbnailClicked: (index: number) => void;
}) {
  const [emblaRef, embla] = useEmblaCarousel({
    loop: false,
    align: "start",
    dragFree: true,
  });

  useEffect(() => {
    if (!embla) return;
    embla.scrollTo(activeIndex);
  }, [activeIndex, embla]);

  return (
    <Box
      className="embla"
      sx={(theme) => ({
        position: "relative",
        overflow: "hidden",
        display: isFullScreen ? "block" : "none",
        [theme.breakpoints.down(AD_DETAILS_2_COLUMN_MAX_WIDTH)]: {
          display: "block",
        },
        "@media (orientation: landscape)": {
          [theme.breakpoints.down("md")]: {
            display: "none",
          },
        },
      })}
    >
      <Box
        className="embla__viewport"
        ref={emblaRef}
        sx={{
          overflow: "hidden",
        }}
      >
        <Box
          className="embla__container"
          sx={{
            display: "flex",
            paddingTop: 1,
            paddingBottom: 1,
          }}
        >
          {items.map((item, index) => (
            <Box
              key={item.thumbnail}
              className="embla__slide"
              sx={(theme) => ({
                flex: `0 0 ${THUMBNAIL_WIDTH}px`,
                minWidth: 0,
                height: THUMBNAIL_HEIGHT + "px",
                marginLeft: index === 0 ? THUMBNAIL_SPACING : undefined,
                marginRight: THUMBNAIL_SPACING,
                position: "relative",
                cursor: "pointer",
                borderWidth: theme.spacing(0.5),
                borderStyle: "solid",
                borderColor:
                  activeIndex === index ? BRAND_COLOR : "transparent",
                borderRadius: theme.spacing(1),
                overflow: "hidden",
              })}
              onClick={() => onThumbnailClicked(index)}
            >
              <Box
                sx={{
                  background: `black url(${item.thumbnail})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  position: "absolute",
                  top: "0",
                  width: "100%",
                  height: "100%",
                  overflow: "hidden",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {item.type === "video" && (
                  <DarkIconButton>
                    <PlayArrowIcon
                      sx={{
                        fontSize: 40,
                      }}
                    />
                  </DarkIconButton>
                )}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default ThumbnailsCarousel;
